module.exports = __webpack_public_path__ + "images/smycken-adelstenar.716dbd2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/EbaySweden.TouchWeb/static/images/category-carousel/smycken-adelstenar.jpg
// module id = 899357c0
// module chunks = 10 37